module.exports = __webpack_public_path__ + "img/113.e1e8f915.jpg";